var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { ChildComponent } from "../../../pages/modules/child-component";
import { LookupValue, LookupValueRequest, LookupValueQuery } from "../../../../models/lookups/lookup.models";
import { Guid } from "../../../../utilities/guid";
import { NotificationType } from "../../../../services/basics/notification-client.service";
import { computedFrom } from "aurelia-binding";
import "website-mobile-preview";
import { DataType, SourceType } from "../../../../models/queries/queries.models";
import * as Enumerable from "linq";
import { CacheLocation } from "../../../../services/basics/client-caching.service";
import { bioMp, ScreenType } from "./boMp";
import { IFramePostMessages } from "../../../../models/modules/lotteryplatform-client.models";
var BrandingPreviewBase = /** @class */ (function (_super) {
    __extends(BrandingPreviewBase, _super);
    function BrandingPreviewBase(element, notificationService, i18N, eventAggregator, tokenClientService, lookupClientService, dialogClientService, brandClientService, attachmentClientService, cacheClient, jsonLockClientService) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.element = element;
        _this.eventAggregator = eventAggregator;
        _this.tokenClientService = tokenClientService;
        _this.lookupClientService = lookupClientService;
        _this.dialogClientService = dialogClientService;
        _this.brandClientService = brandClientService;
        _this.attachmentClientService = attachmentClientService;
        _this.cacheClient = cacheClient;
        _this.jsonLockClientService = jsonLockClientService;
        _this.id = Guid.generateGuid();
        _this.savingPreview = false;
        _this.savingPublish = false;
        _this.screenType = ScreenType.Mac;
        _this.isSavingNewTheme = false;
        return _this;
    }
    Object.defineProperty(BrandingPreviewBase.prototype, "currentTemplate", {
        get: function () {
            return this._currentTemplate;
        },
        set: function (x) {
            var _this = this;
            if (this._currentTemplate == x)
                return;
            this._currentTemplate = x;
            this.loadTemplate(this.currentTemplate ? this.currentTemplate.additionalData.internalName.toLowerCase() : "", this.currentTheme ? this.currentTheme.additionalData.internalName.toLowerCase() : "").then(function (x) {
                // get templates for super admin sidebar
                _this.cacheClient.get("current-theme", CacheLocation.LocalStorage).then(function (x) {
                    _this.loadBrandThemes(x ? x.name : null, false);
                });
                _this.reloadPreview();
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrandingPreviewBase.prototype, "currentTheme", {
        get: function () {
            return this._currentTheme;
        },
        set: function (x) {
            var _this = this;
            if (this._currentTheme == x)
                return;
            this._currentTheme = x;
            this.loadTemplate(this.currentTemplate ? this.currentTemplate.additionalData.internalName.toLowerCase() : "", this.currentTheme ? this.currentTheme.additionalData.internalName.toLowerCase() : "").then(function (x) {
                _this.reloadPreview();
                _this.cacheClient.put("current-theme", _this._currentTheme, CacheLocation.LocalStorage);
            });
        },
        enumerable: false,
        configurable: true
    });
    BrandingPreviewBase.prototype.onItemChanged = function () {
        this.rebindBrandingModel();
    };
    BrandingPreviewBase.prototype.loadTemplate = function (templateName, themeName) {
        return __awaiter(this, void 0, void 0, function () {
            var templateNameLower, themeNameLower, brand, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        templateNameLower = templateName ? templateName.toLowerCase() : null;
                        themeNameLower = themeName ? themeName.toLowerCase() : null;
                        if (templateNameLower == this.templateName && themeNameLower == this.themeName)
                            return [2 /*return*/];
                        if (templateName) {
                            this.templateName = templateNameLower;
                        }
                        if (themeName) {
                            this.themeName = themeNameLower;
                        }
                        if (!(this.themeName && this.templateName)) return [3 /*break*/, 2];
                        brand = this.isManagingDefaultConfig() ? null : this.getBrandDetails();
                        _a = this;
                        return [4 /*yield*/, this.brandClientService.initBrandingModel(this.templateName, this.themeName, brand && brand.brandName ? brand.brandName : '', this.isManagingDefaultConfig(), this.isWidget())];
                    case 1:
                        _a.branding = _b.sent();
                        this.rebindBrandingModel();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    BrandingPreviewBase.prototype.goBack = function () {
        var _this = this;
        var brand = this.isManagingDefaultConfig() ? null : this.getBrandDetails();
        this.jsonLockClientService.removeUserJsonLocks(brand && brand.brandName ? brand.brandName : null, this.templateName).then(function (x) {
            _this.dialogClientService.hide();
        }).catch(function (e) { _this.notificationService.show("Error releasing lock", "Error releasing lock", NotificationType.Error); });
    };
    BrandingPreviewBase.prototype.onActivated = function () {
        var _this = this;
        // get templates for super admin sidebar
        var request = new LookupValueRequest();
        request.lookupValueQuery = this.isWidget() ? LookupValueQuery.lotteryWidgets : LookupValueQuery.templates;
        this.lookupClientService.getLookup(request).then(function (x) {
            var templateValues = x.values;
            // if it's a brand admin we get the template name from the brand
            // else if it's the super admin then he will be able to select the template from the sidebar
            _this.brandTemplate = _this.isManagingDefaultConfig() ? null : _this.getBrandTemplateInternalName();
            _this.templates = {
                columns: [{
                        dataType: DataType.Default,
                        name: 'name',
                        columnOrder: 0,
                        sortOrder: 0
                    }, {
                        dataType: DataType.Boolean,
                        name: 'additionalData',
                        columnOrder: 1,
                        sortOrder: 1,
                        valueConverter: function (x) { return x.internalName == _this.brandTemplate; }
                    }],
                source: Enumerable.from(templateValues).orderBy(function (x) { return x.name; }).toArray(),
                sourceType: SourceType.Collection
            };
            _this.currentTemplate = _this.brandTemplate && !_this.isWidget() ?
                Enumerable.from(templateValues)
                    .firstOrDefault(function (x) { return x.additionalData.internalName == _this.brandTemplate; }) : templateValues[0];
        });
        // initialize preview
        this.reloadPreview();
    };
    BrandingPreviewBase.prototype.loadBrandThemes = function (theme, publishOnLoad) {
        var _this = this;
        var themeRequest = new LookupValueRequest();
        themeRequest.lookupValueQuery = LookupValueQuery.brandThemes;
        var brand = this.isManagingDefaultConfig() ? null : this.getBrandDetails();
        themeRequest.parameters = brand ? brand.brandId.toString() : "";
        this.lookupClientService.getLookup(themeRequest).then(function (x) {
            _this.brandThemesValues =
                _this.isWidget() ?
                    Enumerable.from(x.values).where(function (x) { return x.additionalData && x.additionalData.lotteryWidgetInternalName && x.additionalData.lotteryWidgetInternalName.toLowerCase() == _this.templateName.toLowerCase(); }).toArray()
                    : Enumerable.from(x.values).where(function (x) { return x.additionalData && x.additionalData.templateInternalName && x.additionalData.templateInternalName.toLowerCase() == _this.templateName.toLowerCase(); }).toArray();
            var baseTheme = Enumerable.from(_this.brandThemesValues).firstOrDefault(function (x) { return x.name.toLowerCase() == "base theme"; });
            if (!baseTheme) {
                _this.brandThemesValues.splice(0, 0, {
                    name: "Base Theme",
                    id: 0,
                    isActive: true,
                    additionalData: {
                        internalName: "preview"
                    }
                });
            }
            _this.brandThemes = {
                columns: [{
                        dataType: DataType.Default,
                        name: 'name',
                        columnOrder: 0,
                        sortOrder: 0
                    }, {
                        dataType: DataType.Boolean,
                        name: 'additionalData',
                        columnOrder: 1,
                        sortOrder: 1,
                        isHidden: function (x) {
                            if (_this.isManagingDefaultConfig())
                                return false;
                            var brand = _this.getBrandDetails();
                            return !brand || x.additionalData.brandId != brand.brandId;
                        },
                        valueConverter: function (x) {
                            return x.isCurrentTheme;
                        }
                    }, {
                        dataType: DataType.Icon,
                        name: 'remove',
                        title: "",
                        parameter: function (x) { return x.additionalData && x.additionalData.isInherited ? "settings_backup_restore" : "delete"; },
                        isHidden: function (x) {
                            if (_this.isManagingDefaultConfig())
                                return x.name == "Base Theme";
                            var brand = _this.getBrandDetails();
                            return !brand || x.additionalData.brandId != brand.brandId;
                        },
                        value: function (x) {
                            if (_this.isDeletingTheme)
                                return;
                            _this.isDeletingTheme = true;
                            _this.brandClientService.removeTheme(x.id).then(function (x) {
                                _this.isDeletingTheme = false;
                                setTimeout(function () {
                                    _this.loadBrandThemes(null, false);
                                });
                            }, function (x) {
                                _this.notificationService.show("Failed to delete theme", "", NotificationType.Error);
                                _this.isDeletingTheme = false;
                            });
                        },
                        columnOrder: 1,
                        sortOrder: 1
                    }],
                source: Enumerable.from(_this.brandThemesValues).orderBy(function (x) { return x.name; }).toArray(),
                sourceType: SourceType.Collection
            };
            // if it's a brand admin we get the template name from the brand
            // else if it's the super admin then he will be able to select the template from the sidebar
            var brandTheme = _this.isManagingDefaultConfig() ? null : _this.getBrandThemeInternalName();
            setTimeout(function () {
                if ((brandTheme || theme) && !_this.isWidget()) {
                    var selectedTheme = Enumerable.from(_this.brandThemesValues)
                        .firstOrDefault(function (x) { return theme ? x.name == theme : x.additionalData.internalName.toLowerCase() == brandTheme.toLowerCase(); });
                    _this.currentTheme = selectedTheme ? selectedTheme : _this.brandThemesValues[0];
                }
                else {
                    _this.currentTheme = _this.brandThemesValues[0];
                }
                if (publishOnLoad) { // after we delete a theme we need to republish another on
                    _this.publish();
                }
            });
        });
    };
    BrandingPreviewBase.prototype.selectTemplate = function (event) {
        var _this = this;
        if (event.detail && event.detail.item) {
            var brand = this.isManagingDefaultConfig() ? null : this.getBrandDetails();
            this.jsonLockClientService.removeUserJsonLocks(brand && brand.brandName ? brand.brandName : null, this.templateName)
                .then(function (x) { }).catch(function (e) { _this.notificationService.show("Error releasing lock", "Error releasing lock", NotificationType.Error); });
            this.currentTemplate = event.detail.item;
        }
    };
    BrandingPreviewBase.prototype.selectTheme = function (event) {
        if (event.detail && event.detail.item)
            this.currentTheme = event.detail.item;
    };
    Object.defineProperty(BrandingPreviewBase.prototype, "lang", {
        get: function () {
            return this._lang;
        },
        set: function (x) {
            if (this._lang == x)
                return;
            this._lang = x;
            this.reloadPreview();
        },
        enumerable: false,
        configurable: true
    });
    BrandingPreviewBase.prototype.selectScreenType = function (type) {
        this.screenType = type;
        this.reloadPreview(null, true);
    };
    BrandingPreviewBase.prototype.reloadPreview = function (changeUri, force) {
        if (changeUri === void 0) { changeUri = null; }
        if (force === void 0) { force = false; }
        // super admin controls all brands config not a specific brand
        var brand = this.isManagingDefaultConfig() ? null : this.getBrandDetails();
        if (this.lang && this.brandingModel && this.brandingModel.themeName && this.brandingModel.templateName) {
            var brandParameter = brand && brand.brandId ? "&brandId=".concat(brand.brandId) : "";
            var href = this.buildRouteToNavigate(brandParameter, changeUri);
            if (href == this.routeToNavigate && !force)
                return; //no need to reload since URL didn't have any changes 
            this.routeToNavigate = href;
            var parent = document.getElementById("preview-".concat(this.id));
            if (parent.children.length > 0) {
                for (var i = parent.children.length - 1; i >= 0; i--)
                    parent.removeChild(parent.children.item(i));
            }
            bioMp(document.getElementById("preview-".concat(this.id)), {
                url: href,
                type: this.screenType
            });
        }
    };
    BrandingPreviewBase.prototype.buildRouteToNavigate = function (brandParameter, changeUri) {
        if (changeUri === void 0) { changeUri = null; }
        var route = changeUri ? changeUri : this.getRoute();
        var additionalData = this.getRouteAdditionalData();
        var templateNameParam = this.isWidget() ? "widgetName" : "templateName";
        return window.location.origin + "/preview/".concat(route, "?").concat(additionalData ? (additionalData + '&') : '', "lang=").concat(this.lang.additionalData.code).concat(brandParameter, "&").concat(templateNameParam, "=").concat(this.brandingModel.templateName, "&themeName=").concat(this.brandingModel.themeName, "&isOverlay=").concat(this.isOverlay(), "&isWidget=").concat(this.isWidget());
    };
    BrandingPreviewBase.prototype.getRouteAdditionalData = function () {
        return "";
    };
    BrandingPreviewBase.prototype.isManagingDefaultConfig = function () {
        var lottery = this.item;
        if (this.includesNavigationInfo())
            return !lottery || !lottery.navigationInfo || !lottery.navigationInfo.brandId;
        var brand = this.item;
        var value = !brand || !brand.brandId;
        return value;
    };
    BrandingPreviewBase.prototype.includesNavigationInfo = function () {
        return false;
    };
    Object.defineProperty(BrandingPreviewBase.prototype, "isPreviewLocked", {
        get: function () {
            return this._isPreviewLocked;
        },
        enumerable: false,
        configurable: true
    });
    BrandingPreviewBase.prototype.attached = function () {
        var _this = this;
        this.brandingSteps = this.getBrandingSteps();
        this.checkLockFunc = function (x) {
            if (x && x.data && x.data.event == IFramePostMessages.currentlyLockedPreview) {
                _this._isPreviewLocked = x.data.detail.locked;
                _this.currentlyLocked = x.data.detail.user;
            }
        };
        window.addEventListener('message', this.checkLockFunc, true);
    };
    BrandingPreviewBase.prototype.detached = function () {
        if (this.checkLockFunc)
            window.removeEventListener('message', this.checkLockFunc, true);
        if (this.event) {
            this.event.dispose();
        }
    };
    BrandingPreviewBase.prototype.preview = function () {
        var _this = this;
        var isNew = (this.currentTheme && this.currentTheme.id == 0);
        var baseTheme = (this.currentTheme.additionalData.brandId == null && this.currentTheme.name != "Base Theme");
        var isNewOrBaseTheme = isNew || baseTheme;
        var saveNew = this.isManagingDefaultConfig() ? isNew : isNewOrBaseTheme;
        if (saveNew) { // if its a new theme then we need to publish it first
            this.publish();
        }
        else {
            this.savingPreview = true;
            this.save(false, true, null).then(function (x) {
                if (saveNew)
                    _this.loadBrandThemes(null, false);
                _this.routeToNavigate = null;
                _this.reloadPreview();
                _this.savingPreview = false;
            }).catch(function (e) {
                _this.notificationService.show("Failed to save preview", e && e.response ? e.response : "", NotificationType.Error);
                _this.savingPreview = false;
            });
        }
    };
    BrandingPreviewBase.prototype.publish = function () {
        var _this = this;
        this.savingPublish = true; // activated loading for save & publish button
        this._isPreviewLocked = true; // activated disabled for save & publish button 
        var isNew = (this.currentTheme && this.currentTheme.id == 0);
        var baseTheme = (this.currentTheme.additionalData.brandId == null && this.currentTheme.name != "Base Theme");
        var isNewOrBaseTheme = isNew || baseTheme;
        var saveNew = this.isManagingDefaultConfig() ? isNew : isNewOrBaseTheme;
        this.save(saveNew, false, this.currentTheme.name != "Base Theme" && saveNew ? this.currentTheme.name : null).then(function (x) {
            _this.loadBrandThemes(null, false);
            _this.routeToNavigate = null;
            _this.reloadPreview();
            _this.savingPublish = false; // hide loading for save & publish button 
            _this._isPreviewLocked = false; // hide disabled for save & publish button 
            _this.notificationService.show("Published successfully!", "", NotificationType.Success);
        }, function (e) {
            _this.savingPublish = false; // hide loading for save & publish button 
            _this._isPreviewLocked = false; // hide disabled for save & publish button 
            // this.notificationService.show("Failed to publish", e && e.response ? e.response : "", NotificationType.Error);
        });
    };
    BrandingPreviewBase.prototype.unGroupedImages = function (images) {
        // check if any image has a data uri
        return Enumerable.from(images)
            .select(function (x) { return x.value; })
            .where(function (x) { return x; })
            .selectMany(function (item) {
            return Enumerable.from(item).select(function (x) { return x.value; }).toArray();
        })
            .where(function (x) { return x != null && x != undefined; });
    };
    BrandingPreviewBase.prototype.fixAttachmentPaths = function (response, images) {
        // fix attachment path in config
        // loop through langs
        for (var langKey in images) {
            // loop trough keys
            for (var valueKey in images[langKey]) {
                var data = images[langKey][valueKey];
                if (data && data.startsWith("data:")) // if is data uri
                 {
                    // change it with the response new name
                    var attachment = Enumerable.from(response.attachments).firstOrDefault(function (x) { return x.dataUri == data; });
                    images[langKey][valueKey] = attachment ? attachment.newName : "";
                }
            }
        }
    };
    BrandingPreviewBase.prototype.save = function (saveNewTheme, isPreview, themeName) {
        var _this = this;
        if (themeName === void 0) { themeName = null; }
        return new Promise(function (resolve, reject) {
            var images = _this.getImages();
            var unGroupedImages = Enumerable.from(images).selectMany(function (x) { return _this.unGroupedImages(x); });
            var anyAttachments = unGroupedImages.any(function (x) { return x.startsWith("data:"); });
            if (anyAttachments) { // upload attachments
                _this.attachmentClientService.addAttachments({
                    dataUris: unGroupedImages.toArray(),
                    files: null
                }).then(function (response) {
                    var e_1, _a;
                    try {
                        for (var images_1 = __values(images), images_1_1 = images_1.next(); !images_1_1.done; images_1_1 = images_1.next()) {
                            var item = images_1_1.value;
                            _this.fixAttachmentPaths(response, item);
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (images_1_1 && !images_1_1.done && (_a = images_1.return)) _a.call(images_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    // save branding and lottery
                    _this.saveBranding(saveNewTheme, isPreview, themeName, resolve, reject);
                }, reject);
            }
            else { // no attachments to upload
                // save branding and lottery
                _this.saveBranding(saveNewTheme, isPreview, themeName, resolve, reject);
            }
        });
    };
    BrandingPreviewBase.prototype.saveBranding = function (saveNewTheme, isPreview, themeName, resolve, reject) {
        var _this = this;
        if (this.templateName) {
            var brandId = this.isManagingDefaultConfig() ? null : this.getBrandDetails().brandId;
            this.brandClientService.saveBranding(this.getFilesToSave(), saveNewTheme, this.templateName, themeName ? themeName : this.themeName, isPreview, this.isWidget(), brandId)
                .then(function (x) {
                if (x.hasError) {
                    _this.notificationService.show(_this.i18N.tr("error"), x.errorMessage, NotificationType.Error);
                    reject();
                }
                else {
                    resolve();
                }
            }, reject);
        }
    };
    BrandingPreviewBase.prototype.isOverlay = function () {
        return false;
    };
    BrandingPreviewBase.prototype.isWidget = function () {
        return false;
    };
    // do not remove "branding" it rebinds the views
    BrandingPreviewBase.prototype.rebindBrandingModel = function () {
        // need to do this if statement since there is a bug when bundled
        // this if statement is here so that the preview renders only if the following is fulfilled
        if (!this.templateName || !this.themeName)
            this.brandingModel = null;
        else
            this.brandingModel = {
                isWidget: this.isWidget(),
                model: this.item,
                templateName: this.templateName,
                themeName: this.themeName,
                isManagingDefaultConfig: this.isManagingDefaultConfig(),
                lotteryKey: this.getLotteryKey()
            };
    };
    BrandingPreviewBase.prototype.getLotteryKey = function () {
        return null;
    };
    BrandingPreviewBase.prototype.saveAs = function () {
        this.isSavingNewTheme = true;
    };
    BrandingPreviewBase.prototype.saveAsCancelled = function () {
        this.isSavingNewTheme = false;
    };
    BrandingPreviewBase.prototype.saveAsComplete = function () {
        var _this = this;
        this.save(true, true, this.newSaveAsThemeName).then(function (x) {
            _this.loadBrandThemes(_this.newSaveAsThemeName, false);
            _this.newSaveAsThemeName = "";
            _this.isSavingNewTheme = false;
            _this.notificationService.show("Saved", "New theme saved!", NotificationType.Success);
        }).catch(function (e) {
            _this.notificationService.show("Error Saving", "Could not save new theme!", NotificationType.Error);
        });
    };
    __decorate([
        computedFrom("_lang"),
        __metadata("design:type", LookupValue),
        __metadata("design:paramtypes", [LookupValue])
    ], BrandingPreviewBase.prototype, "lang", null);
    __decorate([
        computedFrom("_isPreviewLocked"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BrandingPreviewBase.prototype, "isPreviewLocked", null);
    return BrandingPreviewBase;
}(ChildComponent));
export { BrandingPreviewBase };
